// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","header":"App_header__fhC8n"};